module.exports = __webpack_public_path__ + "static/favicon-f03790d704b073c32ceff3654d93ad15.jpg";